/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { types } from '../actions/adr';
import { combineAPIReducers } from './api';

export default combineAPIReducers(types);




// WEBPACK FOOTER //
// ./src/redux/reducers/adr.js